import React from 'react';
import '../styles/components/short_news_card.css';
import { formatDate } from '../utils/dateUtil';

const ShortNewsCard = ({ image, date, title }) => {
  return (
    <div className="short-news-card">
      <div className="short-news-card__image-wrapper">
        <img src={image} alt="" className="short-news-card__bg" />
        <img
          src={image}
          alt="Short News"
          className="short-news-card__image"
        />
      </div>

      <p className="short-news-card__date">
        {formatDate(date)}
      </p>
      <p className="short-news-card__title">
        {title}
      </p>
    </div>
  );
};

export default ShortNewsCard;
